import config from 'react-global-configuration';

export let APP_ENV = process.env.REACT_APP_ENV || 'production';
export const __DEBUG__ = APP_ENV !== 'production';
export const USE_SENTRY = process.env.REACT_APP_SENTRY_ENABLED;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export const DEFAULT_LANGUAGE = 'nl';
export const MULTILINGUAL = true;
export const SITE_NAME = 'verpact';
export const APP_ROOT_ELEMENT_ID = 'root';
export const PRIVACY_POLICY = 'https://www.verpact.nl/privacy-en-cookieverklaring';

// `globalThis.ssr` is set by src/server/window.js and is the only reliable
// signal here. Feature-detecting the browser is not enough: the SSR process
// installs a fake window whose document has createElement, so the check below
// reports "client" on the server. It only ever worked because this module
// happened to be evaluated before the fake window existed — import order, not
// intent. Now that setupGlobals installs it up front, we ask outright.
export const IS_SERVER = (
  (typeof globalThis !== 'undefined' && globalThis.ssr === true)
  || !(
    typeof window !== 'undefined'
    && window.document
    && window.document.createElement
  )
);
export const IS_CLIENT = !IS_SERVER;

let API_URL = process.env.REACT_APP_API_URL || '//verpact.devinc.eu';
// let API_URL = 'http://localhost:3000/api'; // <- For local proxy.


// If we provide the API URL in the DOM, use that instead. Guard the lookup: a
// missing root element must not take the whole module down at import time.
const rootElement = IS_CLIENT ? document.getElementById(APP_ROOT_ELEMENT_ID) : null;

if (rootElement?.dataset.apiUrl) {
  API_URL = rootElement.dataset.apiUrl;
}

export const LANGUAGES = {
  nl: 'Ga naar nederlands',
  en: 'Switch to English',
};

// const APOLLO_SEARCH_URL = process.env.REACT_APP_APOLLO_SEARCH_URL || "http://verpact.devinc.eu:4000/";
const APOLLO_SEARCH_URL = process.env.REACT_APP_APOLLO_SEARCH_URL || '/apollo/api/graphql';
const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY || '';

// Searchkit host url.
export let SEARCHKIT_HOST_URL = process.env.REACT_APP_SEARCHKIT_HOST_URL || '/api-proxy/elasticsearch-proxy?_api_proxy_uri=';

export const SEARCH_ALL_CONTENT_HITS_PER_PAGE = 30;

// The value is where the breakpoint starts (mobile-first).
// These values are taken from '/src/src/styles/assets/_variables.scss'.
export const SCREEN_MOBILE = 0;
export const SCREEN_TABLET = 768;
export const SCREEN_NORMAL = 992;
export const SCREEN_WIDE = 1240;
export const SCREEN_HUGE = 2000;

// Block ID constants
export const BLOCK_NEWSLETTER_BLOCK_ID = 3;

// Taxonomy terms
export const TAXONOMY_TERM_HELP_TYPE_GENERAL = 18;
export const TAXONOMY_TERM_HELP_TYPE_ADMINISTRATION = 20;
export const TAXONOMY_TERM_HELP_TYPE_TARIFFS = 19;
export const TAXONOMY_TERM_HELP_TYPE_PPWR = 38;
export const TAXONOMY_TERM_HELP_TYPE_RECYCLING = 39;
export let TAXONOMY_TERM_HELP_TYPE_SUPPORTER = 47;
export const TAXONOMY_TERM_ARTICLE_TYPE_PRESS = 5;

// Certain pages constants
export const PAGES_MORE_NEWS_URL = '/node/472';


export let APP_OPTIONS = {
  apiUrl: API_URL,
  element: '',
  parameters: {
    env: 'production',
    searchkitIndexAllContent: 'elasticsearch_index_afv_prod_content',
    taxonomyTermHelpTypeSupporter: 47,
  }
};

// Use config to share static configuration between components and packages.
config.set({
  'SITE_NAME': SITE_NAME,
  'MULTILINGUAL': MULTILINGUAL,
  'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
  'LANGUAGES': LANGUAGES,
  'API_URL': API_URL,
  'APOLLO_SEARCH_URL': APOLLO_SEARCH_URL,
  'RECAPTCHA_SITE_KEY': RECAPTCHA_SITE_KEY,
  'PAGE_TRANSITION_SPEED': 200,
}, { freeze: false });

export function saveConstants(options) {
  APP_OPTIONS = options;

  if (options.parameters.env) {
    APP_ENV = options.parameters.env;
  }

  if (options.apiUrl) {
    API_URL = options.apiUrl;
  }

  if (options.parameters.taxonomyTermHelpTypeSupporter) {
    TAXONOMY_TERM_HELP_TYPE_SUPPORTER = options.parameters.taxonomyTermHelpTypeSupporter;
  }

  if (APP_ENV === 'development') {
    // Use proxy in dev to prevent CORS issues.
    API_URL = 'http://localhost:3000/api';
    SEARCHKIT_HOST_URL = 'http://localhost:3000/search-proxy';
  }

  // Update the config.
  config.set({
    'SITE_NAME': SITE_NAME,
    'MULTILINGUAL': true,
    'DEFAULT_LANGUAGE': DEFAULT_LANGUAGE,
    'LANGUAGES': LANGUAGES,
    'API_URL': API_URL,
    'APOLLO_SEARCH_URL': APOLLO_SEARCH_URL,
    'RECAPTCHA_SITE_KEY': RECAPTCHA_SITE_KEY,
    'PAGE_TRANSITION_SPEED': 200,
  });
}
